import class_swiper from '../../classes/class.swiper.js';

document.addEventListener("DOMContentLoaded", () => {
   
    const sliderCarousel = document.querySelectorAll('.wp-block-blockem-slidercarousel');
    
    sliderCarousel.forEach((el,index)=>{
       // const settings_string = ;
        const settings_obj = JSON.parse(el.getAttribute('data-settings'));
        const ide = settings_obj.ide;
        const earth3D_element = new class_swiper(el, settings_obj, false);
    })
    
});